import { Card } from "@fluentui/react-components";
import styled from "styled-components";

import { Flex } from "components/styled";

import { AppSpinner } from "components/AppSpinner/AppSpinner";
import { useGetUserAppTargetSetting } from "hooks/useGetUserAppTargetSetting";
import { useSelectedAppThemeFromSettings } from "hooks/useSelectedAppThemeFromSettings";
import { APP_ID, APP_SETTING_ID } from "library/constants";
import { EAppSettings } from "library/types";
import { useAddAppSetting } from "state/queries/useAddAppSetting";
import { useUpdateAppSettings } from "state/queries/useUpdateAppSettings";
import { ColorPickerFluent } from "./ColorPickerFluent/ColorPickerFluent";
import { generateTheme } from "./themeGenerator";

export function ThemeSelector() {
  const themeAppSetting = useGetUserAppTargetSetting({
    targetSettingName: EAppSettings.theme,
  });
  const selectedTheme = useSelectedAppThemeFromSettings();

  const { mutate: onAddAppSetting, isLoading: addSettingsInProgress } =
    useAddAppSetting();
  const { mutate: onUpdateAppSetting, isLoading: updateSettingsInProgress } =
    useUpdateAppSettings();

  const onSelectTheme = (color) => {
    const { lightTheme, darkTheme } = generateTheme(color);

    if (selectedTheme) {
      onUpdateAppSetting({
        payload: [
          {
            ...themeAppSetting,
            userAppSettingValue: JSON.stringify({
              light: lightTheme,
              dark: darkTheme,
            }),
          },
        ] as any,
      });
    } else {
      onAddAppSetting({
        payload: [
          {
            applicationCodeId: APP_ID,
            userAppSettingValue: JSON.stringify({
              light: lightTheme,
              dark: darkTheme,
            }),
            appSettingCodeId: APP_SETTING_ID,
            userAppSettingName: EAppSettings.theme,
            isDefault: false,
          },
        ],
      });
    }
  };
  return (
    <Container>
      {(addSettingsInProgress || updateSettingsInProgress) && <AppSpinner />}

      <Card
        style={{
          width: "100%",
        }}
      >
        <Flex direction="column" $align="flex-start">
          <ColorPickerFluent onSelectTheme={onSelectTheme} />
        </Flex>
      </Card>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const Wrap = styled.div<{ selectedColor?: string }>`
  border: ${({ theme, selectedColor }) =>
    selectedColor
      ? `2px solid ${selectedColor}`
      : `1px solid ${theme.palette.neutralLight}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.palette.white};
  border-radius: 4px;

  @keyframes shine {
    from {
      -webkit-mask-position: 150%;
    }

    to {
      -webkit-mask-position: -50%;
    }
  }

  .icon {
    -webkit-mask-image: linear-gradient(
      -75deg,
      rgba(0, 0, 0, 0.6) 30%,
      #000 50%,
      rgba(0, 0, 0, 0.6) 70%
    );
    -webkit-mask-size: 200%;
    animation: shine 2s infinite;
  }
`;
